import {
  ROUTE_CATEGORIES_ALL,
  ROUTE_MENU,
  ROUTE_SERVICES,
  ROUTE_SHOP,
} from "@/utils/constants";
import { Merchant } from "@/dto/merchant";
import { Category } from "@/dto/category";
import { MerchantBusinessType } from "@/constants/enum";
import { SecondaryCarouselNavigationBar } from "@/components/secondaryCarouselNavigationBar/secondaryCarouselNavigationBar";
import { SecondaryServicesNavigationBar } from "./secondaryServicesNavigationBar";
import { giftCardCategory } from "@/utils/giftCardUtils";
import { filterRestaurantCategories } from "@/utils/itemUtils";

interface SecondaryNavigationProps {
  pathName: string | null;
  merchant: Merchant;
  hasHorizontalScrollFlag: boolean;
  retailCategories: Category[];
  serviceCategories: Category[];
  isScrolledDown?: boolean;
  mappedCategories: Category[];
  moreCategories: Category[];
  scanToOrderInfo: any;
  isNotAcceptingOrder: boolean;
  categories: Category[];
}

export const SecondaryNavigation = ({
  pathName,
  merchant,
  hasHorizontalScrollFlag,
  retailCategories,
  serviceCategories,
  isScrolledDown,
  mappedCategories,
  moreCategories,
  scanToOrderInfo,
  isNotAcceptingOrder,
  categories,
}: SecondaryNavigationProps) => {
  const allowedRoutes = [
    ROUTE_SERVICES,
    ROUTE_MENU,
    ROUTE_SHOP,
    ROUTE_CATEGORIES_ALL,
  ];
  const hasBasicPath = allowedRoutes.some((path) => pathName?.includes(path));

  if (!hasBasicPath) {
    return null;
  }

  const isRestaurantOrService =
    merchant.merchantBusinessType === MerchantBusinessType.RESTAURANT ||
    merchant.merchantBusinessType === MerchantBusinessType.SERVICE;

  if (isRestaurantOrService && hasHorizontalScrollFlag) {
    if (merchant.isHybrid) {
      const categoriesToShow = pathName?.includes(ROUTE_SHOP)
        ? retailCategories
        : serviceCategories.filter(
            (c: Category) => c.id !== giftCardCategory.id
          );

      return (
        <SecondaryCarouselNavigationBar
          categories={categoriesToShow}
          isScrolledDown={isScrolledDown}
        />
      );
    }
    const displayCategories = merchant?.isRestaurant
      ? filterRestaurantCategories(categories)
      : categories;
    return (
      <SecondaryCarouselNavigationBar
        categories={displayCategories}
        isScrolledDown={isScrolledDown}
      />
    );
  } else {
    const displayCategories = merchant?.isRestaurant
      ? filterRestaurantCategories(mappedCategories)
      : mappedCategories;
    const filteredMoreCategories = merchant?.isRestaurant
      ? filterRestaurantCategories(moreCategories)
      : moreCategories;
    return (
      <SecondaryServicesNavigationBar
        displayCategories={displayCategories}
        moreCategories={filteredMoreCategories}
        retailCategories={retailCategories}
        serviceCategories={serviceCategories}
        scanToOrderInfo={scanToOrderInfo}
        isNotAcceptingOrder={isNotAcceptingOrder}
      />
    );
  }
};
